import * as React from "react";
import { useState } from "react";
import Grid from "@mui/material/Grid2";
import GoogleMap from "./GoogleMapContainer";
import { FormInputText } from "../../components/common/FormInputText";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { deliveryAddressSchema } from "../../utilities/schema";
import { Box, Button, Paper, Stack, styled, Typography } from "@mui/material";
import { useNavigate } from "react-router";

const AddressTypeButton = styled(Button)(({ theme, selected }) => ({
  borderRadius: "30px",
  padding: "10px",
  width: "80px",
  height: "32px",
  borderColor: selected ? theme.palette.primary.main : "var(--neutral-300)",
  backgroundColor: selected ? "var(--primary-red-100)" : "transparent",
  color: selected ? theme.palette.primary.main : "var(--neutral-800)",
}));
export default function AddAddress() {
  const navigate = useNavigate();
  const [deliveryType, setDeliveryType] = useState("door_step_delivery");
  const [contactInfo, setContactInfo] = useState({
    name: "Armaan",
    mobile: "7667762218",
  });
  const methods = useForm({
    resolver: yupResolver(deliveryAddressSchema),
  });
  const {
    handleSubmit,
    reset,
    control,
    formState: { errors },
  } = methods;
  return (
    <Grid container spacing={3}>
      <Grid size={6}>
        <Grid container spacing={2}>
          <Grid size={12}>
            <FormInputText
              name="name"
              control={control}
              label="Name"
              errors={errors}
              type="text"
              autofocus={true}
            />
          </Grid>
          <Grid size={12}>
            <FormInputText
              name="mobile"
              control={control}
              label="Mobile"
              errors={errors}
              type="text"
            />
          </Grid>
          <Grid size={6}>
            <FormInputText
              name="door_no"
              control={control}
              label="Door No / Flat"
              errors={errors}
              type="text"
            />
          </Grid>
          <Grid size={6}>
            <FormInputText
              name="area"
              control={control}
              label="Area / Locality"
              errors={errors}
              type="text"
            />
          </Grid>
          <Grid size={6}>
            <FormInputText
              name="street"
              control={control}
              label="Street"
              errors={errors}
              type="text"
            />
          </Grid>
          <Grid size={6}>
            <FormInputText
              name="pincode"
              control={control}
              label="Pincode"
              errors={errors}
              type="text"
            />
          </Grid>
          <Grid size={6}>
            <FormInputText
              name="city"
              control={control}
              label="City / Town"
              errors={errors}
              type="text"
            />
          </Grid>
          <Grid size={6}>
            <FormInputText
              name="state"
              control={control}
              label="State"
              errors={errors}
              type="text"
            />
          </Grid>
          
          <Grid size={12}>
            <Typography
              variant="h4"
              sx={{
                fontWeight: 500,
                fontSize: "14px",
                lineHeight: "157%",
                color: "var(--neutral-800)",
                textAlign: "left",
                pb: 1,
              }}
            >
              Address Type
            </Typography>
            <Stack direction="row" spacing={2}>
              <AddressTypeButton variant="outlined" selected={true}>
                Home
              </AddressTypeButton>
              <AddressTypeButton variant="outlined" selected={false}>
                Work
              </AddressTypeButton>
              <AddressTypeButton variant="outlined" selected={false}>
                Others
              </AddressTypeButton>
            </Stack>
          </Grid>
        </Grid>
      </Grid>
      <Grid size={6}>
        <GoogleMap />
        <Stack direction="row" spacing={2} alignItems={"center"} sx={{ my: 4 }}>
          <Button
            variant="outlined"
            sx={{
              py: 1.5,
              fontSize: "16px",
              width: "100%",
              border: "1px solid var(--primary-red-base)",
            }}
          >
            Cancel
          </Button>

          <Button
            onClick={() => navigate("/pre-checkout")}
            variant="contained"
            sx={{ py: 1.5, fontSize: "16px", width: "100%" }}
          >
            Save
          </Button>
        </Stack>
      </Grid>
    </Grid>
  );
}
